export class WorkstationSettings implements DeviceSettings {
  public init() {}

  public getCaptionState() {
    return false
  }

  public addCaptionChangeEventListener() {}

  public removeCaptionChangeEventListener() {}

  public getVoiceState() {
    return false
  }

  public addVoiceChangeEventListener() {}

  public removeVoiceChangeEventListener() {}

  public getModel(): Promise<DeviceModel> {
    return Promise.resolve({
      id: '',
      name: 'workstation',
      type: '',
      version: '',
    })
  }

  public getOS() {
    return {
      name: '',
      version: '',
    }
  }

  public getAppStoreURL(): string {
    return 'placeholder'
  }

  public getAppIDForAds(): string {
    return 'placeholder'
  }

  public getVendor() {
    return 'workstation'
  }

  public getRDID(): string {
    //TODO
    return ''
  }

  public isLATEnabled(): boolean {
    //TODO
    return false
  }
}
